import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';

import { AppComponent } from './app.component';
import { NbThemeModule } from '@nebular/theme';
import { AppRoutingModule } from './app-routing.module';

import { ToasterModule, ToasterService } from 'angular2-toaster';

import { AuthModule } from './auth/auth.module';

import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';
registerLocaleData(localePT, 'pt', localeExtraPT);

//Componentes
import { DatagridModule } from './components/datagrid/datagrid.module';
import { TableParcelasComponent } from './components/table-parcelas/table-parcelas.component';
import { ModalTableParcelasComponent } from './components/table-parcelas/modal-table-parcelas.component';
import { TableParcelasModule } from './components/table-parcelas/table-parcelas.module';
import { SelectHelpperModule } from './components/select-helpper/select-helpper.module';

//Services
import { AuthGuard } from './auth/auth-guard.service';
import { RoutinesService } from '../services/routines.service';
import { SessionStorageService } from '../services/session-storage.service';
import { MyToasterService } from '../services/my-toaster.service';
import { DatagridEventEmitter } from '../services/datagrid-event-emitter';
import { CaracteresEspeciais } from '../services/caracteres-especiais';

import { CurrencyMaskModule } from "ng2-currency-mask";
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask/src/currency-mask.config";

// import { environment } from '../environments/environment';
import { DatePipe, DecimalPipe } from '@angular/common';

import { AgmCoreModule } from '@agm/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalBanksEmmiter } from '../services/modal-banks.service';

import { ShareButtonsModule } from '@ngx-share/buttons'; //https://murhafsousli.github.io/ngx-sharebuttons/#/share-buttons-component
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { NotificationService } from '../services/notification.service';
import { LoadingService } from '../services/loading.service';

// pipes
import { PipesModule } from './pipes/pipes.module';

// modal component
import { ModalNewSimulatorModule } from './components/modal-newsimulator/modal-newsimulator.module';

import { HistoricoCanaisComponent } from './components/historico-canais/historico-canais.component';
import { HistoricoCanaisModule } from './components/historico-canais/historico-canais.module';

import { CommissionsModalComponent } from './pages/commissions/modal/commissions-modal.component';
import { CommissionsModalModule } from './pages/commissions/modal/commissions-modal.module';

import { ProcessService } from '../services/process.service';
import { PropostaService } from '../services/proposta.service';
import { CurrencyRealReplacerPipe } from './pipes/currency-real-replacer.pipe';

import { NgSelectModule } from '@ng-select/ng-select';//https://github.com/ng-select/ng-select
import { DashboardData } from '../services/dashboard-data';
import { IncorporadoraService } from '../services/incorporadora.service';
import { IncorporadorasModalModule } from './pages/incorporadoras/modal/incorporadoras-modal.module';
import { IncorporadorasModalComponent } from './pages/incorporadoras/modal/incorporadoras-modal.component';
import { ProcessModalModule } from './pages/process/modal/process-modal.module';
import { ProcessModalComponent } from './pages/process/modal/process-modal.component';
import { ProcessStatusService } from '../services/process-status.service';

import { IncorporadoraHeaderService } from '../services/incorporadora-header.service';
import { FieldEditModule } from './components/field-edit/field-edit.module';
import { FieldEditComponent } from './components/field-edit/field-edit.component';
import { ChartsModule } from 'ng2-charts/ng2-charts';
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
	align: "left",
	allowNegative: false,
	allowZero: true,
	decimal: ",",
	precision: 2,
	prefix: "R$ ",
	suffix: "",
	thousands: "."
};

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		NbThemeModule.forRoot({ name: 'default' }),
		AppRoutingModule,
		DatagridModule,
		AuthModule,
		SelectHelpperModule,
		CurrencyMaskModule,
		NgbModule.forRoot(),
		AgmCoreModule.forRoot({
			// apiKey: environment.gmapsKey,
			libraries: ["places"]
		}),
		ToasterModule,
		HttpClientModule,
		HttpClientJsonpModule,
		ShareButtonsModule.forRoot(),
		TableParcelasModule,
		PipesModule,
		ModalNewSimulatorModule,
		FieldEditModule,
		HistoricoCanaisModule,
		CommissionsModalModule,
		NgSelectModule,
		IncorporadorasModalModule,
		ChartsModule,
		ProcessModalModule,
	],
	providers: [
		AuthGuard,
		RoutinesService,
		SessionStorageService,
		MyToasterService,
		DatagridEventEmitter,
		DatePipe,
		DecimalPipe,
		ToasterService,
		ModalBanksEmmiter,
		NotificationService,
		LoadingService,
		DashboardData,
		{ provide: LOCALE_ID, useValue: 'pt' },
		{ provide: APP_BASE_HREF, useValue: '/' },
		{ provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
		CaracteresEspeciais,
		CurrencyRealReplacerPipe,
		ProcessService,
		PropostaService,
		IncorporadoraService,
		IncorporadoraHeaderService,
		ProcessStatusService,
	],
	bootstrap: [AppComponent],
	entryComponents: [
		TableParcelasComponent,
		ModalTableParcelasComponent,
		HistoricoCanaisComponent,
		CommissionsModalComponent,
		IncorporadorasModalComponent,
		FieldEditComponent,
		ProcessModalComponent,
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts